"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _react = _interopRequireDefault(require("react"));
var _DefaultThemConfig = _interopRequireDefault(require("./DefaultThemConfig"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var DisplayErr = function DisplayErr(_ref) {
  var classes = _ref.classes,
    table = _ref.table,
    customTheme = _ref.customTheme;
  var tableMsg = table.tableMsg;
  var themeConfig = (0, _core.createTheme)({
    overrides: _objectSpread(_objectSpread({}, (0, _DefaultThemConfig.default)()), customTheme)
  });
  return /*#__PURE__*/_react.default.createElement(_core.ThemeProvider, {
    theme: themeConfig
  }, /*#__PURE__*/_react.default.createElement(_core.Container, {
    className: classes.errContainer
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "errMsgText"
  }, tableMsg && tableMsg.noMatch)));
};
var styles = function styles() {
  return {
    errContainer: {
      textAlign: 'center',
      height: '40px',
      paddingTop: '10px'
    }
  };
};
var _default = (0, _core.withStyles)(styles)(DisplayErr);
exports.default = _default;